import * as portuguese from './pt.json';

export default {
    pt: portuguese,
}